function ComponentPropBuilder () {
    this.componentProps = {};

    this.withCommonProp = commonPropObj => {
        const { componentProps } = this;
        const { commonProps = {} } = componentProps;
        componentProps.commonProps = { ...commonProps, ...commonPropObj };
        return this;
    }

    this.withColumnProp = (fieldName, columnPropObj) => {
        const { componentProps } = this;
        const { [fieldName] : fieldProps = {} } = componentProps;
        componentProps[fieldName] = {...fieldProps, ...columnPropObj};
        return this;
    }

    this.getProps = () => this.componentProps;

    return this;
}

export default ComponentPropBuilder;
